module.exports = __webpack_public_path__ + "static/media/quotes.72afd4f2.svg";